module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'charts' && templateVars.config ?
				templateVars.config :
				{
	"chartsWithTableLegend": [
		"#chart_example"
	],
	"chartsWithFewTypeValuesTableLegend": [
		{
			"id": "#chart1_2",
			"cols": {
				"col1": {
					"type": "name",
					"title": ""
				},
				"col2": {
					"type": "percents",
					"title": "доля в потреблении"
				},
				"col3": {
					"type": "absolute",
					"title": "тыс. т"
				}
			}
		},
		{
			"id": "#chart1_7",
			"cols": {
				"col1": {
					"type": "name",
					"title": ""
				},
				"col2": {
					"type": "percents",
					"title": "доля в потреблении"
				},
				"col3": {
					"type": "absolute",
					"title": "тыс. т"
				}
			}
		},
		{
			"id": "#chart1_8",
			"cols": {
				"col1": {
					"type": "name",
					"title": ""
				},
				"col2": {
					"type": "percents",
					"title": "доля в потреблении"
				},
				"col3": {
					"type": "absolute",
					"title": "тыс. т"
				}
			}
		},
		{
			"id": "#chart2_2",
			"cols": {
				"col1": {
					"type": "name",
					"title": ""
				},
				"col2": {
					"type": "percents",
					"title": "share in consumption"
				},
				"col3": {
					"type": "absolute",
					"title": "kt"
				}
			}
		},
		{
			"id": "#chart2_7",
			"cols": {
				"col1": {
					"type": "name",
					"title": ""
				},
				"col2": {
					"type": "percents",
					"title": "share in consumption"
				},
				"col3": {
					"type": "absolute",
					"title": "kt"
				}
			}
		},
		{
			"id": "#chart2_8",
			"cols": {
				"col1": {
					"type": "name",
					"title": ""
				},
				"col2": {
					"type": "percents",
					"title": "share in consumption"
				},
				"col3": {
					"type": "absolute",
					"title": "kt"
				}
			}
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/charts/config.yaml
// module id = 143
// module chunks = 0